import { render, staticRenderFns } from "./ShowPost.vue?vue&type=template&id=bded6480&"
import script from "./ShowPost.vue?vue&type=script&lang=js&"
export * from "./ShowPost.vue?vue&type=script&lang=js&"
import style0 from "./ShowPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports